/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { GlobalContainer } from '../../../common';

interface INotificationsContainerStyledProps {
    $withMargin?: boolean;
}

const TabMenuContainerStyled = styled.div.attrs({
    'data-main-menu': 'mainMenu',
})`
    position: relative;
    display: flex;
    align-items: center;
    flex-grow: 2;
    flex-wrap: nowrap;
    justify-content: flex-start;
    min-width: 0;
    height: 64px;
    border-top: 1px solid ${colors.corporateHeaderSeparateBorderColor};
`;

const HeaderSelectorContainerStyled = styled.div`
    border-left: 1px solid ${colors.corporateHeaderSeparateBorderColor};
    border-top: 1px solid ${colors.corporateHeaderSeparateBorderColor};
`;
const HeaderNotificationsContainerStyled = styled.div<INotificationsContainerStyledProps>`
    flex: 1;
    display: flex;
    justify-content: end;
    & .user-notifications {
        margin: ${(props) => (props.$withMargin ? '0 12px' : 0)};
    }
`;

const CorporateHeaderContainerStyled = styled(GlobalContainer)`
    display: flex;
    flex-wrap: nowrap;
    padding: 0 40px;
`;

const TabMenuCounterStyled = styled.div.attrs({
    className: 'corporate-header__counter',
})`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 24px;
    height: 24px;
    margin-left: 8px;
    border-radius: 100%;
    box-sizing: border-box;
    background: ${colors.corporateHeaderCounterBg};
    ${fonts.textSmallBold};
    color: ${colors.corporateHeaderCounterFont};
    cursor: pointer;
    text-align: center;
`;

export {
    CorporateHeaderContainerStyled,
    HeaderSelectorContainerStyled,
    HeaderNotificationsContainerStyled,
    TabMenuContainerStyled,
    TabMenuCounterStyled,
};
